import produce from 'immer';
import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import { initialStateQALiability as initialState } from './qaLiabilityStateDefaultValue';
import { ApiStatus } from '../../types';
import {
    QALiabilityApiEndpoints,
    QALiabilityDataPayload,
    QALiabilityFormDetail,
    QALiabilityState,
    QALiabilityUserAction,
} from './qaLiabilityTypes';

const QALiabilitySlice = createSlice({
    name: 'QALiability',
    initialState,
    reducers: {
        updateQALiabilityEndpoints: (state, action: PayloadAction<QALiabilityApiEndpoints>) => {
            state.apiEndpoints = action.payload;
        },
        getQALiabilityData(state) {
            state.qaLiabilityApiStatus = ApiStatus.Pending;
        },
        getQALiabilityDataFulfilled(state, action: PayloadAction<QALiabilityDataPayload> ) {
            const { liabilitiesVerificationContent } = action.payload;

            state.qaLiabilityApiStatus = ApiStatus.Fulfilled;
            state.qaLiabilityData = action.payload;

            if (liabilitiesVerificationContent) {
                state.content = JSON.parse(liabilitiesVerificationContent);
            }
        },
        getQALiabilityDataRejected(state) {
            state.qaLiabilityApiStatus = ApiStatus.Rejected;
        },
        getQALiabilityDataInvalid(state) {
            state.qaLiabilityApiStatus = ApiStatus.Pending;
        },
        updateValidationCheck(state, action: PayloadAction<boolean>) {
            state.validationCheck = action.payload;
        },
        updateUserAction(state, action: PayloadAction<QALiabilityUserAction>) {
            return produce(state, (draftState) => {
                const {
                    categoryName,
                    subCategoryId,
                    id,
                    selectedVerificationAction,
                } = action.payload;

                const changedCategory = draftState.qaLiabilityData.categoriesRequired.filter(item => item.categoryName === categoryName)[0].data;
                const changedQALiabilityData = changedCategory.filter(item => item.subCategoryId === subCategoryId && item.id === id)[0];

                Object.assign(changedQALiabilityData, {
                    selectedVerificationAction: selectedVerificationAction,
                });

                draftState.noUserActionIdList = draftState.noUserActionIdList.filter(item => item !== id);

            });
        },
        updateNoUserActionIdList(state, action: PayloadAction<number[]>)  {
            state.noUserActionIdList = action.payload;
        },
        updateQALiabilityFormDetail(state, action: PayloadAction<QALiabilityFormDetail>){
            state.qaLiabilitySubmitStatus = ApiStatus.Pending;
        },
        updateQALiabilityFormDetailFulfilled(state) {
            state.qaLiabilitySubmitStatus = ApiStatus.Fulfilled;
        },
        updateQALiabilityFormDetailRejected(state) {
            state.qaLiabilitySubmitStatus = ApiStatus.Rejected;
        },
        resetQALiabilityFormDetailStatus(state) {
            state.qaLiabilityApiStatus = ApiStatus.Idle;
            state.qaLiabilitySubmitStatus = ApiStatus.Idle;
        },
    },
});

export const {
    updateQALiabilityEndpoints,
    getQALiabilityData,
    getQALiabilityDataFulfilled,
    getQALiabilityDataRejected,
    getQALiabilityDataInvalid,
    updateValidationCheck,
    updateUserAction,
    updateNoUserActionIdList,
    updateQALiabilityFormDetail,
    updateQALiabilityFormDetailFulfilled,
    updateQALiabilityFormDetailRejected,
    resetQALiabilityFormDetailStatus,
} = QALiabilitySlice.actions;

export const QALiabilityReducer: Reducer<QALiabilityState, AnyAction> = QALiabilitySlice.reducer;
